import { handleClick } from "@/shared/Analitics/GoogleAnalytics4";
import { ContainerCollectionSaveExit } from "./styles";
import ContentIcon from "@/shared/ContentIcon"; 


const CollectionSaveExit = ({ onClick }) => {

    return (
        <ContainerCollectionSaveExit className="message-collection">
            <p>Sumá la receta a tus</p>
            <a href="/recetas/colecciones" className="link__collection"  onClick={() => handleClick("ui_interaction", "Recetas", "Recetas colecciones")}>
                Recetas Guardadas
            </a>
            <button type="button" onClick={onClick}>
                <ContentIcon width= "18px" height="18px" nameIcon='closeIco'/>
            </button>
        </ContainerCollectionSaveExit>
    );
}

export default CollectionSaveExit;